import type { ReactNode } from 'react';

/**
 * El `.input-wrap-clear` del mock: envuelve un campo y le monta el × que lo vacía de un clic.
 * El botón solo aparece con contenido y con el campo habilitado; vaciar algo apagado no es una acción.
 */
export function ClearableField({
    label,
    filled,
    disabled,
    onClear,
    children,
}: {
    /** Cómo se nombra el campo en el `aria-label` del botón. */
    label: string;
    filled: boolean;
    disabled?: boolean;
    onClear: () => void;
    children: ReactNode;
}) {
    return (
        <span className="relative block">
            {children}
            {filled && !disabled ? (
                <button
                    type="button"
                    aria-label={`Limpiar ${label}`}
                    onClick={onClear}
                    className="absolute right-1 top-1.5 inline-flex size-4 items-center justify-center rounded-full text-[11px] leading-none text-muted-foreground transition-colors hover:bg-muted hover:text-destructive"
                >
                    ×
                </button>
            ) : null}
        </span>
    );
}
